export const SET_SHOW_MODAL = 'SET_SHOW_MODAL'
export const SET_CLOSE_MODAL = 'SET_CLOSE_MODAL'
